import React from 'react';
import FadeIn from 'react-fade-in';

type LoaderProps = {
}

const Loader: React.FC<LoaderProps> = (props) => {

  return (
    <div className="loader position-absolute">
      <FadeIn>
        <div className={ `circle-loader` }>
          <div className="checkmark draw"></div>        
        </div>
      </FadeIn>
    </div>
  );
};

export default Loader;